import React from 'react';
import PropTypes from 'prop-types';
import { useStyles } from './styles';

export function ActionLink (props) {
    const {
        view = '#',
        label = '',
        commonUIStyles = {},
        onClick = () => {},
    } = props;

    const classes = useStyles({
        commonUIStyles,
    });
  
    return (
        <a href={view}
           className={classes.link}
           onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                if (typeof onClick === 'function') {
                    onClick();
                }
           }}
        >
            { label }
        </a>
    );
}

ActionLink.propTypes = {
    view: PropTypes.string,
    label: PropTypes.string,
    commonUIStyles: PropTypes.any,
    onClick: PropTypes.func,
};

export default ActionLink;
